import { useCallback, useEffect, useState } from "react";
import { getSyllabus } from "../../../../services/StudentPortal/StudentSyllabusService";
import { unwrapList } from "../../utils/studentPortalUtils";
import { handleApiError } from "../../../../utils/errorHandler";

// Loads the syllabus list once on mount, normalized into a flat array via
// unwrapList so StudentSyllabus.js never has to guess the response shape.
// Confirmed against the real backend (2026-10-22): student_id, program_id
// AND session_id are all required — session_id alone 500s with "Undefined
// index: session_id" (SyllabusController.php:406).
export const useStudentSyllabus = (studentId, programId, sessionId) => {
  const [syllabusItems, setSyllabusItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchSyllabus = useCallback(async () => {
    if (!studentId || !programId || !sessionId) return;
    setIsLoading(true);
    try {
      const response = await getSyllabus({ student_id: studentId, program_id: programId, session_id: sessionId });
      setSyllabusItems(unwrapList(response));
    } catch (error) {
      handleApiError(error);
      setSyllabusItems([]);
    } finally {
      setIsLoading(false);
    }
  }, [studentId, programId, sessionId]);

  useEffect(() => {
    fetchSyllabus();
  }, [fetchSyllabus]);

  return { syllabusItems, isLoading };
};

export default useStudentSyllabus;
